import MoneyInput from 'components/MoneyInput';
import React from 'react';
import { Box } from '@mui/material';
import { useResourceContext } from 'react-admin';
import { formatCents } from 'utils/rateSettings/SharedRateSettingsForm.utils';
import { useRateControllerContext } from '../rateController/RateControllerContext';
import { deriveInheritedRatePreview } from '../rateController/rateControllerModel';
import { RateFieldCheckbox } from './RateFieldCheckbox';

type Props = { source: string; inheritedSettings?: any };

export const BaseChargeRateCentsInput = ({ source, inheritedSettings = {} }: Props) => {
  const resource = useResourceContext();
  const { isControlled } = useRateControllerContext();
  const isLocationLevel =
    resource === 'LocationPositionRateSetting' || resource === 'AgencyLocationPositionRateSetting';
  const label = isLocationLevel ? 'Base Location Rate' : 'Base 8hr Charge Rate';
  const disabled = !isControlled('baseChargeRate');

  const inheritedBase = deriveInheritedRatePreview({
    inherited: inheritedSettings,
    source,
    isLocationLevel,
  }).baseChargeRate;

  return (
    <Box display="flex" alignItems="center" gap={1}>
      <MoneyInput
        source={`${source}.base_charge_rate_cents`}
        label={label}
        disabled={disabled}
        sx={{ flex: 1 }}
        helperText={formatCents(inheritedBase)}
      />
      <RateFieldCheckbox code="baseChargeRate" label="Admin controls Base Charge Rate" />
    </Box>
  );
};
